import React from "react";
import styles from "src/components/atoms/Loader/styles.module.css";
import { Msg } from "src/i18n/Msg";

export const Loader: React.FC = () => (
  <div className={styles.loaderWrapper}>
    <div className={styles.dots}>
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
    </div>
    <p className={styles.text}>
      <Msg id="components.atoms.Loader.text" />
    </p>
  </div>
);
